'use client';
import Lottie from 'lottie-react';
import { BoxComponent, BoxComponentProps } from '../box/Box';
// const LoaderAnimation = require('./assets/mainLoader.json');
import * as LoaderAnimation from './assets/mainLoader.json';
import { SxProps, Theme } from '@mui/material';
//TODO: Change this 'require' import to regular import

export interface BaseLoaderProps extends BoxComponentProps {
  container?: SxProps<Theme>;
}

export function BaseLoader({ container, ...otherProps }: BaseLoaderProps) {
  return (
    <BoxComponent
      sx={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...container,
      }}
    >
      <BoxComponent {...otherProps} sx={{ '& svg > g >g:last-child': { display: 'none !important' } }}>
        <Lottie animationData={LoaderAnimation} loop={true} />
      </BoxComponent>
    </BoxComponent>
  );
}
